<template>
  <div class="app flex-row align-items-center" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h3 class="text-center">Khôi phục mật khẩu</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert=false"
                >{{mData.dataDefault.error}}</b-alert>
                <b-alert
                  class="alert-reset-pass-success"
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="mData.dataDefault.showDismissibleAlertSuccess=false"
                >
                  <p>{{mData.dataDefault.success}}</p>
                  <p>Vui lòng liên hệ 19006888 để được hỗ trợ nếu không nhận được tin nhắn thông báo OTP.</p>
                </b-alert>

                 <!-- <b-alert
                  class="alert-reset-pass"
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertMessage"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertMessage = false
                  "
                  >
                    <p class="otp">
                      Bạn sẽ nhận được tin nhắn có nội dung tương tự như: "xxxxx_Ma kich hoat de doi mat khau tren ung dung DU LICH VIET NAM AN TOAN:
                      <span class="otp-text">****</span> "
                      <span class="otp-title">
                        <img class="otp-image-web" src="img/mui-ten.png">
                        Đây là mã OTP
                      </span>
                    </p>
                  </b-alert> -->

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <el-form-item label="Nhập mã khôi phục" prop="code">
                    <el-input
                      auto-complete="off"
                      prefix-icon="el-icon-key"
                      v-model.trim="mData.dataForm.code"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Nhập mật khẩu" prop="pass">
                    <el-input
                      auto-complete="off"
                      prefix-icon="el-icon-lock"
                      v-model.trim="mData.dataForm.pass"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Nhập lại mật khẩu" prop="repass">
                    <el-input
                      auto-complete="off"
                      prefix-icon="el-icon-lock"
                      v-model.trim="mData.dataForm.repass"
                      show-password
                    ></el-input>
                  </el-form-item>

                  <el-form-item class="text-center mt-4">
                    <el-button
                      type="primary"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                    >Xác nhận</el-button>
                  </el-form-item>
                </el-form>
                <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
export default {
  data() {
    var checkRePassword = (rule, value, callback) => {
      if (value !== this.mData.dataForm.pass) {
        callback(new Error('Mật khẩu nhập lại không khớp'))
      } else {
        callback()
      }
    }
    var checkLength = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('Mật khẩu có tối thiểu 6 ký tự'))
      } else {
        callback()
      }
    }
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          showDismissibleAlertMessage: false
        },
        dataForm: {
          account: "",
          code: "",
          pass: "",
          repass: ""
        },
        validForm: {
          account: [ValidService.required],
          code: [ValidService.required],
          pass: [ValidService.required, { validator: checkLength, trigger: 'change' }, { validator: checkLength, trigger: 'blur' }],
          repass: [ValidService.required, { validator: checkRePassword, trigger: 'change' }, { validator: checkRePassword, trigger: 'blur' }]
        }
      }
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(valid => {
        if (valid) {
          if (this.mData.dataForm.pass != this.mData.dataForm.repass) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error =
              "Mật khẩu và nhập lại mật khẩu không khớp";
            MethodService.stopLadda();
            return;
          }
          AuthService.resetPassword(
            this.mData.dataForm.account,
            this.mData.dataForm.code,
            this.mData.dataForm.repass
          )
            .then(res => {
              this.$message({
                showClose: true,
                message: "Đăng nhập bằng mật khẩu mới thành công",
                type: "success",
                duration: 6000 //8s
              });
              AuthService.login(
                this.mData.dataForm.account,
                this.mData.dataForm.repass
              )
                .then(res => {
                  this.$router.push({ name: "Admin-Home" });
                })
                .catch(error => {
                  this.mData.dataDefault.showDismissibleAlert = true;
                  this.mData.dataDefault.error = "Đăng nhập không thành công";
                });
            })
            .catch(error => {
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error = "Khôi phục không thành công";
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    }
  },
  mounted: function() {
    if (this.$router.currentRoute.query.account) {
      this.mData.dataForm.account = this.$router.currentRoute.query.account;
      this.mData.dataDefault.showDismissibleAlertSuccess = true;
      this.mData.dataDefault.showDismissibleAlertMessage = true;
      this.mData.dataDefault.success =
        this.$router.currentRoute.params && this.$router.currentRoute.params.msg ? this.$router.currentRoute.params.msg : "";
        // "Mã code đã được gửi tới số điện thoại thành công, kiểm tra tin nhắn để lấy mã code";

        // "Mã code đã được gửi tới " +
        // this.mData.dataForm.account +
        // " thành công, kiểm tra email để lấy mã code";
    }
  }
};
</script>
<style>
.alert-reset-pass-success p{
  margin-bottom: 0;
}
.alert-reset-pass .otp{
  line-height: 25px;
  margin-bottom: 0;
  color: black;
}
.alert-reset-pass .otp .otp-text{
  color: red;
  font-weight: bold;
  border: 1px solid;
  padding: 5px;
  border-radius: 15px;
}
.alert-reset-pass .otp .otp-title{
  margin-left: 5px;
  color: red;
  font-weight: bold;
}
.alert-reset-pass .otp .otp-image-web{
  width: 15%;
  transform: rotate(25deg);
}
</style>
